import { Suits } from '../../Tiles/TileSet';
import { getMatchScore } from '../../Config/Tiles';
import { IBoardMap } from '../../Game/BoardArrangement';
import Tile from '../../Tiles/Tile';
import { getMatch } from '../../State/reducers/level';
import BoardUtils from '../../Game/BoardUtils';
import { IStateBoard } from '../../State/reducers/board';

export class BoardManagerUtils {
    public static getScoreForSuit(boardMap: IBoardMap, id: string) {
        const suit = boardMap[id].tileType.suit as Suits;
        return getMatchScore(suit);
    }

    public static findBoardMatches(
        board: IStateBoard,
        onlyAvailable: boolean = false
    ): Array<[Tile, Tile]> {
        let tiles = board.boardTiles.filter(t => t.tileType.suit !== Suits.SPECIAL) as Tile[];

        if (onlyAvailable) {
            const available = board.available;
            tiles = tiles.filter(t => available.indexOf(t.boardId) !== -1);
        }

        const realPairs: Array<[Tile, Tile]> = tiles.reduce((acc, item) => {
            const set = acc.find(
                arr =>
                    item.tileType.suit !== Suits.BOOSTER &&
                    getMatch([
                        BoardUtils.formatId(arr[0].tileType),
                        BoardUtils.formatId(item.tileType),
                    ]) &&
                    arr.length < 2
            );
            if (set) {
                set.push(item);
            } else {
                acc.push([item]);
            }
            return acc;
        }, []);

        return realPairs;
    }
}
